import { render, staticRenderFns } from "./disputedReads.vue?vue&type=template&id=23f45f38&scoped=true"
import script from "./disputedReads.vue?vue&type=script&lang=js"
export * from "./disputedReads.vue?vue&type=script&lang=js"
import style0 from "./disputedReads.vue?vue&type=style&index=0&id=23f45f38&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23f45f38",
  null
  
)

export default component.exports